import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import { DataGrid, GridEditInputCell, GridCellEditStopReasons, useGridApiContext } from "@mui/x-data-grid";
import { width } from "@mui/system";
import './biddingApprovalList.css';
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD, PIT_ROLES } from "../../../common/constants";
import { authKey, DOWNLOAD_DOCUMENT, GET_BIDDING_APPROVAL_LIST, ADD_APPROVE_BIDDING_LIST, GET_BIDDING_TRANSACTION, TRIGGER_BID_NOTIFICATION, GET_BIDDINGS_LIST_BY_REQ_NUMBER } from "../../../common/URLs";
import { loaderService } from "../../../common/custom-loader/loader-service";

import moment from "moment";
import { Container, Grid, Stack, Typography, Dialog, DialogActions, DialogContent, Tab, Card, Button, TextField, Checkbox, IconButton, CardContent } from "@mui/material";
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Link from "@mui/material/Link";
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import Badge from 'react-bootstrap/Badge';
import { Clear as CancelIcon, Done as ApproveIcon } from '@mui/icons-material';
import { PIT_VALIDATIONS, VALIDATION, capitalizeFunction } from "../../../common/commonValidations";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { AttachFileIcon, FileIcon, NotificationAddIcon, PictureAsPdf, PictureAsPdfIcon, TableViewIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import { type } from "@testing-library/user-event/dist/type";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import abeplLogo from "../../../images/abeplLogo.png";
import * as XLSX from 'xlsx';

function BiddingApprovalList() {

    const navigate = useNavigate();
    const [biddingApprovalList, setBiddingApprovalList] = useState();
    const [approveButtonData, setApproveButtonData] = useState();
    const [approveDataList, setApproveDataList] = useState();
    const [tabValue, setTabValue] = React.useState("Pending");
    const [openPopup, setOpenPopup] = useState(false);
    const [biddingTransactionData, setBiddingTransactionData] = useState();
    const [addComment, setAddComment] = useState('');

    const [userRole, setUserRole] = useState();
    const location = useLocation();
    const [commentError, setCommentError] = useState("");
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const [logModalOpen2, setLogModalOpen2] = useState(false);
    const handleLogModalOpen2 = () => setLogModalOpen2(true);
    const handleLogModalClose2 = () => { setLogModalOpen2(false); getBiddingApprovalList(); }
    const [quantity, setQuantity] = useState({
        approvedQuantity: ""
    });
    const [selectedID, setSelectedID] = useState();
    const [errorMessage, setErrorMessage] = useState({
        splitQtyError: '',
        noRecordError: '',
    });

    const [characterLimit] = useState(500);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    }

    const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
        loaderService.showLoader();
        return fetch(DOWNLOAD_DOCUMENT,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    AuthKey: authKey,
                },
                body: JSON.stringify({
                    "fileName": documentBlobName,
                    "containerName": "pit",
                    "file": ""
                })
            })
            .then((response) => response.blob()
            )
            .then((blob) => {
                if (type === "View") {
                    const fileName = finalfileName
                    const splittedName = fileName.split('.')
                    const fileExtension = splittedName[splittedName.length - 1];
                    let fileType;
                    switch (fileExtension) {
                        case 'pdf':
                            fileType = 'application/pdf';
                            break;
                        case 'png':
                            fileType = 'image/png';
                            break;
                        case 'jpg':
                            fileType = 'image/jpeg';
                            break;
                        case 'jpeg':
                            fileType = 'image/jpeg';
                            break;
                        default:
                            fileType = 'application/octet-stream';
                    }
                    const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
                    const newWindow = window.open(url, '_blank');
                    newWindow.focus();
                }
                else {
                    const a = document.createElement("a");
                    a.style.display = "none";
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = finalfileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    const onhandleChange = (e, selectedTransporterId) => {
        (biddingApprovalList?.forEach(item => {
            if (item?.transportId === selectedTransporterId) {
                item.approvedQuantity = e.target.value
            }
            return item;
        }
        ))

    }
    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow }
        biddingApprovalList.forEach((item) => {
            if (item.transportId === updatedRow.transportId) {
                item.approvedQuantity = updatedRow.approvedQuantity
            }
        })
        return updatedRow
    };



    const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
        },
    }));

    function EditInputCell(props) {
        const { error, id, value: valueProp, field } = props;
        const [value, setValue] = useState(valueProp);
        const apiRef = useGridApiContext();

        const handleChange = (event) => {
            const newValue = event.target.value;
            apiRef.current.setEditCellValue({ id, field, value: newValue });
            setValue(newValue);
        };

        useEffect(() => {
            setValue(valueProp);
        }, [valueProp]);

        return (
            <StyledTooltip open={!!error} title={error}>
                <GridEditInputCell {...props} value={value} onChange={handleChange} />
            </StyledTooltip>
        );
    }

    function renderEdit(params) {
        return <EditInputCell {...params} />;
    }

    const onViewDetails = (row) => {
        navigate('./biddingDetails', {
            state: { selectedRow: row }
        });
    }
    const [selectedIds, setSelectedIds] = useState([])
    const selectedRows = biddingApprovalList?.filter((row) => selectedIds?.includes(row?.id));

    const columns = [
        // {
        //     field: 'checkbox',
        //     headerName: 'Select All',
        //     width: 120,
        //     renderHeader: () => (
        //         <Checkbox
        //             checked={selectedIds.length === biddingApprovalList.length}
        //             onChange={(event) => event.target.checked ? setSelectedIds(biddingApprovalList.map((item) => item.id)) : setSelectedIds([])}
        //         />
        //     ),
        //     renderCell: (params) => (
        //         <Checkbox
        //             checked={selectedIds.includes(params.row.id)}
        //             onChange={(event) => handleCheckboxChange(event, params.row)}
        //         />
        //     ),
        // },

        // {
        //     field: 'allotmentRequestNumber', headerName: 'Request Number', width: 160,
        //     renderCell: (params) => { return (<Link to={params} onClick={() => { handleClickOpen(params) }}>{params.value}</Link>) }
        // },
        {
            field: 'bidNumber', headerName: 'Bid Number', width: 290,
            renderCell: (params) => { return (<Link to={params} onClick={() => { handleClickOpen(params.row) }}>{params.value}</Link>) }
        },
        { field: 'bidId', headerName: 'Bid Submission Number', width: 300 },
        { field: 'transporterName', headerName: 'Transporter Name', width: 150 },

        {
            field: 'allotmentQuantity', headerName: 'Quantity(MT)', type: 'number', width: 150,
            valueGetter: params => params?.value?.toFixed(2),
        },
        { field: 'firstPartyLocationAddress', headerName: 'Origin', width: 230, },
        { field: 'secondPartyLocationAddress', headerName: 'Destination', width: 240, },
        {
            field: 'materialType', headerName: 'Material Type', width: 140, valueFormatter: (params) => {
                if (params.value === 'ChipBamboo') {
                    return 'Chip bamboo';
                }
                else if (params.value === 'RawBamboo') {
                    return 'Raw bamboo';
                }
            }
        },
        {
            field: 'baseBidPrice', headerName: 'Base Rate(per ton per KM)', type: 'number', width: 200,
            valueGetter: params => params?.value?.toFixed(2),
        },

        {
            field: 'biddingStartDate', headerName: 'Bidding Start Date', width: 150,
            valueFormatter: params => params.value !== null ? moment(params?.value).format("DD/MM/YYYY") : "",
        },
        {
            field: 'biddingEndDate', headerName: 'Bidding End Date', width: 150,
            valueFormatter: params => params.value !== null ? moment(params?.value).format("DD/MM/YYYY") : "",
        },
        {
            field: 'biddingStartTime', headerName: 'Bidding Start Time', width: 150,
            valueFormatter: (params) => {
                const timeStr = params?.value;
                if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return '-';
                const [hour, minute] = timeStr.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            }
        },
        {
            field: 'biddingEndTime', headerName: 'Bidding End Time', width: 150,
            valueFormatter: (params) => {
                const timeStr = params?.value;
                if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return '-';
                const [hour, minute] = timeStr.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            }

        },
        {
            field: 'biddingValue', headerName: 'Lowest Bid', type: 'number', width: 180,
            valueGetter: params => params?.value?.toFixed(4),
        },
        {
            field: 'decrementValue', headerName: 'Decrement Value', type: 'number', width: 160,
            valueGetter: params => params?.value?.toFixed(4),
        },
        {
            field: 'bidDocumentList',
            headerName: 'Documents',
            width: 300,
            renderCell: (params) => {
                const docs = params.value || [];
                if (docs.length === 0) return "No files";
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {docs.map((doc) => (
                            <Link
                                // key={index}
                                onClick={(e) => viewdownloadDocument(doc?.biddingTermsFileId, doc?.biddingTermsFileName, "Download")}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                            >
                                {doc.biddingTermsFileName}
                            </Link>
                        ))}
                    </div>
                );
            }
        },
        {
            field: 'viewaction', headerName: 'Action', width: 180,
            renderCell: (params) => (
                <>
                    {/* <Tooltip title="View Document">
                        <IconButton color="primary" variant="contained" sx={{ minWidth: 50 }} disabled={params?.row?.biddingTermsFileId === null} onClick={(e) => viewdownloadDocument(params?.row?.biddingTermsFileId, params?.row?.biddingTermsFileName, "Download")} >{params?.row?.biddingTermsFileId === null ? "" : <FileIcon />}</IconButton>
                    </Tooltip> */}
                    <Tooltip title="Export PDF">
                        <IconButton color="primary" variant="contained" sx={{ minWidth: 50 }} onClick={(e) => onExportPdf(params.row, "pdf")} ><PictureAsPdfIcon /></IconButton>
                    </Tooltip>
                    <Tooltip title="Export Excel">
                        <IconButton color="primary" variant="contained" sx={{ minWidth: 50 }} onClick={(e) => onExportPdf(params.row, "excel")} ><TableViewIcon /></IconButton>
                    </Tooltip>
                </>
            )
        },

    ];

    const column2 = [
        { field: 'allotmentRequestNumber', headerName: 'Request Number', width: 180 },
        // {
        //     field: 'schedulePickupDate', headerName: 'PickUp Date', width: 100,
        //     valueFormatter: params => params?.value != null ? moment(params?.value).format("DD/MM/YYYY") : " "
        // },
        {
            field: 'approvedQuantity', headerName: 'Approved Quantity(MT)', width: 180,
            renderCell: (params) => {
                return (
                    params.row.isSplitQuantity === true ? params.row.approvedQuantity?.toFixed(4) : params.row.allotmentQuantity?.toFixed(4)
                )
            },
        },
        {
            field: 'allotmentQuantity', headerName: 'Quantity(MT)', type: 'number', width: 180,
            valueGetter: params => params?.value?.toFixed(2),
        },
        // { field: 'uom', headerName: 'UOM', width: 100 },
        { field: 'firstPartyLocationAddress', headerName: 'Origin', width: 130, },

        { field: 'secondPartyLocationAddress', headerName: 'Destination', width: 140, },
        // {
        //     field: 'scheduledDeliveryDate', headerName: 'Delivery Date', width: 100,
        //     valueFormatter: params => params?.value != null ? moment(params?.value).format("DD/MM/YYYY") : " "
        // },
        {
            field: 'materialType', headerName: 'Material Type', width: 140, valueFormatter: (params) => {
                if (params.value === 'ChipBamboo') {
                    return 'Chipped bamboo';
                }
                else if (params.value === 'RawBamboo') {
                    return 'Raw bamboo';
                }
            }
        },

        {
            field: 'rate', headerName: 'Base Rate(per ton per KM)', type: 'number', sortable: false, width: 200,
        },
        // { field: 'stakeholderUrn', headerName: 'Current Transporter', width: 150 },
        {
            field: 'biddingStartDate', headerName: 'Bidding Start Date', width: 150,
            valueFormatter: params => params?.value != null ? moment(params?.value).format("DD/MM/YYYY") : "",
        },
        {
            field: 'biddingEndDate', headerName: 'Bidding End Date', width: 150,
            valueFormatter: params => params?.value != null ? moment(params?.value).format("DD/MM/YYYY") : "",
        },
        {
            field: 'biddingValue', headerName: 'Lowest Bid', type: 'number', width: 180,
            valueGetter: params => params?.value?.toFixed(2),
        },
        { field: 'bidStakeholderUrn', headerName: 'Bid By (URN)', width: 150 },
        { field: 'approver1Comment', headerName: 'Comments(Approver 1)', width: 300 },
        { field: 'approver2Comment', headerName: 'Comments(Approver 2)', width: 300 },
        { field: 'approver3Comment', headerName: 'Comments(Approver 3)', width: 300 },
        {
            field: 'viewaction', headerName: 'Action', width: 180,
            renderCell: (params) => (
                <Tooltip title="View Document">
                    <IconButton color="primary" sx={{ minWidth: 70 }} variant="contained" disabled={params?.row?.biddingTermsFileId === null} onClick={(e) => viewdownloadDocument(params?.row?.biddingTermsFileId, params?.row?.biddingTermsFileName, "Download")} >{params?.row?.biddingTermsFileId === null ? "" : <FileIcon />}</IconButton>
                </Tooltip>
            )
        },

    ];

    const column3 = [
        // { field: 'allotmentRequestNumber', headerName: 'Request Number', width: 180 },
        {
            field: 'bidNumber', headerName: 'Bid Number', width: 290,
        },
        { field: 'stakeholderUrn', headerName: 'Stakeholder URN', width: 150, },
        { field: 'allotmentQuantity', headerName: 'Quantity(MT)', type: "number", width: 130, },
        {
            field: 'baseBidPrice', headerName: 'Base Rate(per ton per KM)', type: 'number', width: 180,
            valueGetter: params => params?.value?.toFixed(2),
        },
        {
            field: 'biddingValue', headerName: 'Bidding Value', type: 'number', width: 180,
            valueGetter: params => params?.value?.toFixed(2),
        },
        {
            field: 'biddingDate', headerName: 'Bidding Date', width: 120,
            valueFormatter: params => params?.value != null ? moment(params?.value).format("DD/MM/YYYY") : " "
        },
        // { field: 'isBiddingApproved', headerName: 'Is Approved', width: 90, },
        // { field: 'approvedBy', headerName: 'Approved By', width: 100, },
        // {
        //     field: 'approvedDate', headerName: 'Approved Date', width: 110,
        //     valueFormatter: params => params?.value != null ? moment(params?.value).format("DD/MM/YYYY") : " "
        // },

    ];

    const handleClickOpen = (row) => {
        setOpenPopup(true);
        loaderService.showLoader();
        apiClient
            .post(GET_BIDDING_TRANSACTION,
                {
                    "allotmentRequestNumber": row?.allotmentRequestNumber,
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }, null
            ).then((response) => {
                setBiddingTransactionData(response.data.spotBiddingAllotment);
                loaderService.hideLoader();
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const handleClose = () => {
        setOpenPopup(false);
    }

    useEffect(() => {
        setUserRole(location?.state?.data);
    }, []);

    useEffect(() => {
        setBiddingApprovalList([]);
        getBiddingApprovalList();
    }, [tabValue, userRole]);

    const getBiddingApprovalList = () => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_BIDDING_APPROVAL_LIST,
                {
                    "type": "",
                    "approverType": ""
                    // "type": tabValue,
                    // "approverType": localStorage.getItem('role') == PIT_ROLES.TransportationIncharge ? "Approver1" : localStorage.getItem('role') == PIT_ROLES.FinanceUser ? "Approver2" : "Approver3",
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token')
                    },
                },
                null
            )
            .then((response) => {
                setBiddingApprovalList(response.data.spotBiddingAllotment.map((item) => ({ ...item, isValidSplitQuantity: true })));
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error.message);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const onExportPdf = (row, type) => {
        loaderService.showLoader();
        apiClient
            .post(GET_BIDDINGS_LIST_BY_REQ_NUMBER,
                {
                    "allotmentRequestNumber": row.allotmentRequestNumber,
                    "bidNumber": row.bidNumber
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    if (type === "pdf") {
                        Mypdf(response.data.spotBiddingAllotment)
                    }
                    if (type === "excel") {
                        MyDoc(response.data.spotBiddingAllotment);
                    }
                }
                else toast.error(response.data.message);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    const onApproveButtonClick = () => {
        let tempArr = biddingApprovalList.map(item => {
            const fileteredArray = selectedRows.filter((filterItem) => filterItem.id === item.id)
            const sum = fileteredArray.reduce((total, item) => total + Number(item.approvedQuantity), 0);
            if (fileteredArray?.length > 1 && sum !== item.actualScheduleQuantity && selectedRows.find((findItem) => findItem.id === item.id)) {
                item.isValidSplitQuantity = false
            }
            else {
                item.isValidSplitQuantity = true
            }
            return item
        });
        setBiddingApprovalList(tempArr);

        if (!tempArr.every((item) => item.isValidSplitQuantity === true)) {
            toast.error("Sum of splited quantity should be equal to scheduled quantity");
        }
        else {
            let tempArray = []
            selectedRows?.map((item, index) => {
                tempArray.find((tempItem) => tempItem.weeklyScheduleId === item.id) ? tempArray.map((tempItem) => {
                    if (tempItem.weeklyScheduleId === item.id) {
                        return (
                            tempItem.bidDetails.push({
                                "transportId": item.transportId,
                                "actualScheduleQuantity": item.actualScheduleQuantity,
                                "isSplitQuantity": item.isSplitQuantity,
                                "approvedQuantity": item.approvedQuantity ? item.approvedQuantity : item.actualScheduleQuantity
                            })
                        )
                    }

                })
                    : tempArray.push(
                        {
                            "weeklyScheduleId": item.id,
                            "bidDetails": [
                                {
                                    "transportId": item.transportId,
                                    "actualScheduleQuantity": item.actualScheduleQuantity,
                                    "isSplitQuantity": item.isSplitQuantity,
                                    "approvedQuantity": item.approvedQuantity ? item.approvedQuantity : item.actualScheduleQuantity
                                }
                            ]
                        }
                    )
            })
            apiClient
                .post(
                    ADD_APPROVE_BIDDING_LIST,
                    {
                        "schedules": tempArray,
                        "comment": addComment,
                        "approverType": localStorage.getItem('role') == PIT_ROLES.TransportationIncharge ? "Approver1" : localStorage.getItem('role') == PIT_ROLES.FinanceUser ? "Approver2" : "Approver3",
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + getLocalStorageItem('id_token')
                        }
                    },
                    null
                )
                .then((response) => {
                    setApproveButtonData(response.data);
                    getBiddingApprovalList();
                    setErrorMessage({ ...errorMessage, splitQtyError: "" });
                    loaderService.hideLoader();
                })
                .catch(function (error) {
                    console.log(error);
                    loaderService.hideLoader();
                    toast.error(error.message);
                })
        }

    };

    useEffect(() => {
        if (approveButtonData) {
            if (approveButtonData.isSuccess === true) {
                toast.success(approveButtonData?.message)
            } else {
                toast.error(approveButtonData?.message ? approveButtonData?.message : "Error")
            }
        }
    }, [approveButtonData]);

    const onTextValueChange = (e) => {
        setAddComment(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 500)));
        setErrorMessage({ ...errorMessage, noRecordError: "" });
    }

    const handleCheckboxChange = (event, row) => {
        const selectedId = row.id;
        const isSelected = event.target.checked;
        const newSelectedIds = isSelected
            ? [...selectedIds, selectedId]
            : selectedIds.filter((id) => id !== selectedId);
        setSelectedIds(newSelectedIds);
    };

    const Mypdf = (exportData) => {
        const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });

        const pageWidth = doc.internal.pageSize.getWidth();

        // === Centered Logo ===
        const logoWidth = 60;
        const logoHeight = 50;
        const logoX = (pageWidth - logoWidth) / 2;
        const logoY = 20;

        doc.addImage(abeplLogo, 'PNG', logoX, logoY, logoWidth, logoHeight);

        // === Title ===
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('Bidding List', pageWidth / 2, logoY + logoHeight + 25, { align: 'center' });

        // === Show Bid Number (assuming same for all rows) ===
        const bidNumber = exportData[0]?.bidNumber || 'N/A';
        doc.setFontSize(11);
        doc.setFont('helvetica', 'normal');
        doc.text(`Bid Number: ${bidNumber}`, pageWidth / 2, logoY + logoHeight + 45, { align: 'center' });

        // === Origin and Destination (left aligned) ===
        const origin = `Origin: ${exportData[0]?.firstPartyName}, ${exportData[0]?.firstPartyLocationAddress} `;
        const destination = `Destination: ${exportData[0]?.secondPartyName}, ${exportData[0]?.secondPartyLocationAddress}`;
        const materialType = `Material Type: ${exportData[0]?.materialType === "ChipBamboo" ? "Chip Bamboo" : exportData[0]?.materialType === "RawBamboo" ? "Raw Bamboo" : ""}`
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.text(origin, 40, logoY + logoHeight + 70);
        doc.text(destination, 40, logoY + logoHeight + 90);
        doc.text(materialType, 40, logoY + logoHeight + 110);

        // === Find lowest bid value ===
        // === Find minimum bid ===
        const minBidValue = Math.min(...exportData.map(d => Number(d.biddingValue)));

        // === Table ===
        autoTable(doc, {
            startY: logoY + logoHeight + 130,
            head: [[
                'Bid Submission Number', 'Transporter Name', 'Quantity (MT)',
                'Base Rate(per ton per KM)', 'Bidding Start Date',
                'Bidding End Date', 'Bidding Start Time', 'Bidding End Time', 'Lowest Bid'
            ]],
            body: exportData.map((row) => [
                row.bidId,
                row.transporterName,
                row.allotmentQuantity,
                row.baseBidPrice,
                moment(row.biddingStartDate).format('DD/MM/YYYY'),
                moment(row.biddingEndDate).format('DD/MM/YYYY'),
                moment(row.biddingStartTime, 'HH:mm:ss').format('hh:mm A'),
                moment(row.biddingEndTime, 'HH:mm:ss').format('hh:mm A'),
                row.biddingValue
            ]),
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: 'linebreak'
            },
            headStyles: {
                fillColor: [41, 128, 185],
                textColor: [255, 255, 255]
            },
            columnStyles: {
                0: { cellWidth: 120 }, // Adjust widths for better layout
                2: { cellWidth: 40 },
                4: { cellWidth: 50 },
                8: { cellWidth: 70 }
            },
            didParseCell: function (data) {
                // Highlight the lowest bid value cell
                const colIndex = 8; // "Lowest Bid" column
                if (
                    data.section === 'body' &&
                    data.column.index === colIndex &&
                    Number(data.cell.raw) === minBidValue
                ) {
                    data.cell.styles.fillColor = [255, 223, 0]; // Yellow
                    data.cell.styles.textColor = [0, 0, 0];      // Black text
                    data.cell.styles.fontStyle = 'bold';
                }
            },
            tableWidth: 'auto',
        });

        doc.save('ABEPL_Biddings_List.pdf');
    };

    const MyDoc = (exportData) => {
        // Prepare rows
        const rows = exportData.map((row) => ({
            'Bid Number': row.bidNumber,
            'Bid Submission Number': row.bidId,
            'Transporter Name': row.transporterName,
            'Quantity (MT)': row.allotmentQuantity,
            'Origin': row.firstPartyLocationAddress,
            'Destination': row.secondPartyLocationAddress,
            'Material Type': row.materialType === "ChipBamboo" ? "Chip Bamboo" :
                row.materialType === "RawBamboo" ? "Raw Bamboo" : "",
            'Base Rate(per ton per KM)': row.baseBidPrice,
            'Bidding Start Date': moment(row.biddingStartDate).format('DD/MM/YYYY'),
            'Bidding End Date': moment(row.biddingEndDate).format('DD/MM/YYYY'),
            'Bidding Start Time': moment(row.biddingStartTime, 'HH:mm:ss').format('hh:mm A'),
            'Bidding End Time': moment(row.biddingEndTime, 'HH:mm:ss').format('hh:mm A'),
            'Lowest Bid': row.biddingValue
        }));

        // Find min bid to highlight
        const minBid = Math.min(...exportData.map(d => +d.biddingValue));

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(rows);

        // Highlight min bid cell
        const bidCol = Object.keys(rows[0]).indexOf('Lowest Bid');
        rows.forEach((_, rowIndex) => {
            const cellAddress = XLSX.utils.encode_cell({ c: bidCol, r: rowIndex + 1 });
            const cell = ws[cellAddress];
            if (cell && +cell.v === minBid) {
                cell.s = {
                    fill: { fgColor: { rgb: "FFFF00" } }, // Yellow
                    font: { bold: true }
                };
            }
        });

        // Create workbook & export
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Bidding List');

        XLSX.writeFile(wb, 'ABEPL_Biddings_List.xlsx');
    };

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT33</p>}
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                    <Typography variant="h4" gutterBottom>
                        Bidding List
                    </Typography>
                    <Button variant="contained" color="primary" onClick={(e) => getBiddingApprovalList()} style={{ marginBottom: 10 }}>
                        Refresh
                    </Button>
                </Stack>
                <Card>
                    <CardContent>
                        {
                            biddingApprovalList &&
                            <Box mb={2} sx={{ height: 400, width: '100%' }} >
                                <DataGrid
                                    rows={biddingApprovalList}
                                    columns={columns}
                                    pageSize={10}
                                    rowsPerPageOptions={[10]}
                                    getRowId={(row) => row.id}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                    selectionModel={selectedRows.map((item) => item.id)}
                                    experimentalFeatures={{ newEditingApi: true }}
                                    processRowUpdate={(e) => processRowUpdate(e)}
                                    isCellEditable={(params) => params.row.isSplitQuantity === true}
                                    getCellClassName={(params) => {
                                        return !params.row.isValidSplitQuantity && 'themeFailure';
                                    }}
                                    inputProps={{
                                        maxLength: 6
                                    }}
                                />

                            </Box>
                        }

                        <div className="error-msg">
                            {errorMessage.splitQtyError}
                        </div>
                    </CardContent>
                    {/* <TabContext value={tabValue} style={{ marginLeft: "1.5vh" }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'whitesmoke' }}>
                            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                <Tab label="Pending Approvals" value="Pending" />
                                <Tab label="Approved Bidding" value="Approve" />
                            </TabList>
                        </Box>
                        <TabPanel value="Pending">
                            {
                                biddingApprovalList &&
                                <Box mb={2} sx={{
                                    height: 450,
                                    '& .super-app-theme--header': {
                                        wordWrap: 'break-word',
                                        wordBreak: 'break-all',
                                        whiteSpace: 'initial',
                                    },
                                    '& .MuiDataGrid-cell--editable': {
                                        bgcolor: (theme) =>
                                            theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                                    },
                                    '& .super-app.confirmationStatusPending': {
                                        backgroundColor: '#FFFF8F',
                                        color: '#1a3e72',
                                        fontWeight: '600',
                                    },
                                    '& .super-app.confirmationStatusRejected': {
                                        backgroundColor: '#F88379',
                                        color: '#1a3e72',
                                        fontWeight: '600',
                                    },
                                    '& .super-app.confirmationStatusConfirmed': {
                                        backgroundColor: '#ECFFDC',
                                        color: 'green',
                                        fontWeight: '600',
                                    },
                                    '& .themeFailure': {
                                        backgroundColor: '#FF7F7F',
                                        color: '#1a3e72',
                                    },
                                    '& .Mui-error': {
                                        backgroundColor: `rgb(126,10,15,0.1)`,
                                        color: (theme) => theme.palette.error.main,
                                    },
                                }}>

                                    <DataGrid
                                        rows={biddingApprovalList}
                                        columns={columns}
                                        pageSize={10}
                                        rowsPerPageOptions={[10]}
                                        getRowId={(row) => row.transportId}
                                        components={{ Toolbar: QuickSearchToolbar }}
                                        selectionModel={selectedRows.map((item) => item.transportId)}
                                        experimentalFeatures={{ newEditingApi: true }}
                                        processRowUpdate={(e) => processRowUpdate(e)}
                                        isCellEditable={(params) => params.row.isSplitQuantity === true}
                                        getCellClassName={(params) => {
                                            return !params.row.isValidSplitQuantity && 'themeFailure';
                                        }}
                                        inputProps={{
                                            maxLength: 6
                                        }}
                                    />

                                </Box>
                            }

                            <div className="error-msg">
                                {errorMessage.splitQtyError}
                            </div>
                            <Grid container mt={1}>
                                <Grid item xs={12} md={6}>
                                    <TextField fullWidth required
                                        error={errorMessage.noRecordError}
                                        helperText={errorMessage.noRecordError}
                                        autoComplete="off"
                                        id="outlined-multiline-static"
                                        label="Comments"
                                        multiline
                                        rows={4}
                                        onChange={onTextValueChange}
                                        value={addComment}
                                        disabled={selectedRows?.length < 1}
                                        sx={{ paddingRight: '15%' }}
                                    />
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '10%' }}>
                                        <Badge bg={`${addComment?.length > characterLimit ? 'danger' : 'primary'}`}>{addComment?.length}/{characterLimit}</Badge>
                                    </div>
                                </Grid>
                            </Grid>

                            <Box display='flex' alignItems="center" justifyContent="center" mt={3} mb={1} style={{ float: "right" }}>
                                <Button sx={{ minWidth: 100 }} variant="contained" disabled={selectedRows?.length < 1} onClick={(e) => approve(e)} startIcon={<ApproveIcon />}>
                                    Approve
                                </Button>
                            </Box>
                        </TabPanel>
                        <TabPanel value="Approve">
                            <Box sx={{ height: 400, width: '100%' }}>
                                {
                                    biddingApprovalList &&
                                    <DataGrid
                                        rows={biddingApprovalList}
                                        columns={column2}
                                        pageSize={10}
                                        getRowId={(row) => row.transportId}
                                        components={{ Toolbar: QuickSearchToolbar }}
                                        rowsPerPageOptions={[10]} />
                                }
                            </Box>
                        </TabPanel>
                    </TabContext> */}
                </Card>

            </Container>
            {/* <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmTrigger} onClose={handleConfirmClose} action="Trigger Bid Notification" /> */}

            <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
                <DialogContent>
                    <ConfirmPopover title={approveButtonData?.message ? approveButtonData?.message : "Error"} hideLink={true} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLogModalClose2}>OK</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth={true} open={openPopup} onClose={handleClose}>
                <DialogContent>
                    <Box sx={{ height: 300, width: "100%" }}>
                        {biddingTransactionData &&
                            <DataGrid
                                rows={biddingTransactionData}
                                getRowId={(row) => row.bidValueId}
                                columns={column3}
                                rowsPerPageOptions={[5]}
                                pageSize={5} />
                        }
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>OK</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default BiddingApprovalList;